export enum AuditOperationTypeEnum {
  Add = 0,
  Update,
  Delete,
}
